module.exports = __webpack_public_path__ + "img/Data_customer.42be6221.png";